import React from 'react';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationActionMui from '@material-ui/core/BottomNavigationAction';
import { withStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedOutlinedIcon from '@material-ui/icons/RadioButtonUncheckedOutlined';
import FormGroup from '@material-ui/core/FormGroup';
import _ from 'lodash';
import { UNIT } from '../../../constants/theme';

const CommonBottomNavigation = ({
  collection,
  selectedMode,
  generalDesign,
  classes,
  onChange,
  onCheck,
  idCheck
}) => {
  const BottomNavigationAction = withStyles({
    root: {
      '&$selected': {
        border: '2px solid #000'
      }
    },
    iconOnly: {
      padding: UNIT * 0.3125
    },
    selected: {
      color: generalDesign && selectedMode === 0 ? 'white!important' : 'black !important',
      background: generalDesign && selectedMode === 0 && 'black'
    }
  })(BottomNavigationActionMui);
  return (
    <>
      <FormGroup>
        <BottomNavigation
          showLabels
          value={selectedMode}
          onChange={onChange}
          style={{ justifyContent: 'flex-start' }}
        >
          {_.map(collection, (c, index) => {
            const { label, icon } = c;
            return (
              <BottomNavigationAction
                key={index}
                className={
                  idCheck && idCheck === 'etiquetteCheck'
                    ? classes.bottomNavigProduct
                    : classes.bottomNavig
                }
                value={index}
                label={label}
                icon={icon}
                style={{
                  marginLeft: index === 1 && UNIT * 1.6875
                }}
              />
            );
          })}
        </BottomNavigation>
      </FormGroup>
      <div
        style={{
          marginTop: idCheck && idCheck === 'etiquetteCheck' ? UNIT * 7.8125 : UNIT * 5.375
        }}
        className='row mb-4'
      >
        {selectedMode === 0 ? (
          <>
            <CheckCircleIcon className='col-6' onClick={onCheck} />

            <RadioButtonUncheckedOutlinedIcon
              onClick={onCheck}
              className={`col-6 ${classes.checkOutStyle}`}
            />
          </>
        ) : (
          <>
            {' '}
            <RadioButtonUncheckedOutlinedIcon
              onClick={onCheck}
              className={`col-6 ${classes.checkOutStyle}`}
            />
            <CheckCircleIcon className='col-6' onClick={onCheck} />
          </>
        )}
      </div>
    </>
  );
};

export default CommonBottomNavigation;
